export default __webpack_public_path__ + "media/images/images_v2/btnsupp-fb35fdb8b9a03e58085893fcdb9e4323.png";